export default "__VITE_ASSET__7N$70Yhz__"